export default __webpack_public_path__ + "static/media/team-photo-2008.45207d74.jpg";